<div class="position-relative">
  <mat-form-field class="form-group" [hideRequiredMarker]='true'
    [class.mat-form-field-invalid]="!selectedRecords.length && isSubmitted" [class.ng-invalid]="!selectedRecords.length && isSubmitted" (click)="clickout(null)"
    [class.loading-field]="recordsLoading">
    <mat-label>{{ 'complaint.complaintCategoriesAndSubcategories' | translate }}</mat-label>
    <mat-chip-grid #chipRecordsList [required]="required">
      <mat-chip-row *ngFor="let node of selectedRecords; index as i;" [hidden]="i >= 5"
        (removed)="selectedRecords.splice(i, 1);removeRecord(node)">
        {{node.name}}
        <mat-icon matChipRemove>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15">
            <path id="times-hexagon"
              d="M15.5,6.782,13.173,2.691A3.32,3.32,0,0,0,10.3,1H5.6A3.322,3.322,0,0,0,2.731,2.691L.4,6.782a3.493,3.493,0,0,0,0,3.436l2.327,4.091A3.32,3.32,0,0,0,5.6,16h4.7a3.322,3.322,0,0,0,2.871-1.691L15.5,10.218a3.493,3.493,0,0,0,0-3.436ZM14.351,9.531l-2.326,4.091A1.993,1.993,0,0,1,10.3,14.636H5.6a1.992,1.992,0,0,1-1.722-1.015L1.552,9.531a2.094,2.094,0,0,1,0-2.061L3.878,3.378A1.993,1.993,0,0,1,5.6,2.364h4.7a1.992,1.992,0,0,1,1.722,1.015l2.327,4.091A2.094,2.094,0,0,1,14.351,9.531ZM10.425,6.936,8.9,8.5l1.524,1.563a.694.694,0,0,1,0,.964.653.653,0,0,1-.94,0L7.961,9.464,6.437,11.027a.653.653,0,0,1-.94,0,.694.694,0,0,1,0-.964L7.021,8.5,5.5,6.936a.694.694,0,0,1,0-.964.652.652,0,0,1,.94,0L7.961,7.536,9.485,5.972a.652.652,0,0,1,.94,0A.694.694,0,0,1,10.425,6.936Z"
              transform="translate(0.049 -1)" fill="#6b6d85" />
          </svg>
        </mat-icon>
      </mat-chip-row>
      <mat-chip *ngIf="selectedRecords.length > 5" class="more-plus" (click)="showRecordsTree = true">
        +{{selectedRecords.length - 5}}
      </mat-chip>
      <input style="width: 1px;" autocomplete="off" matInput [matChipInputFor]="chipRecordsList">
    </mat-chip-grid>
    <mat-icon matSuffix>{{showRecordsTree ? 'expand_less' : 'expand_more'}}</mat-icon>
  </mat-form-field>
  <ng-container *ngIf="recordsTree.length && !isDisabled">
    <div class="tree-dropdown" [ngClass]="{'position-absolute': isFilter}" [hidden]="!showRecordsTree" #treeDropdown>
      <input class="search_field" placeholder="Search..." #searchInput [formControl]="searchCtrl" autocomplete="off"
        [matChipInputFor]="chipRecordsList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur" (keyup)="filterTree(searchInput.value,true)">
      <app-tree-selection-entities [TREE_DATA]='recordsTree' [stopAutoParentSelection]="stopAutoParentSelection"
        [isSubmitted]="isSubmitted" [searchText]="searchInput.value" [isRequired]="required" [removeItem]="removeItem"
        [selectedInput]="detailsSelectedRecords" (selectedItems)="updateSelectedRecords($event)">
      </app-tree-selection-entities>
    </div>
  </ng-container>
  <p class="mat-mdc-form-field-error mat-mdc-form-field-bottom-align" style="margin-top: -30px;" *ngIf="required &&!selectedRecords.length && isSubmitted">
    {{ 'forms.Required' | translate }}
  </p>

</div>
